import { render, staticRenderFns } from "./StartRefund.vue?vue&type=template&id=2d388f6f&scoped=true&"
import script from "./StartRefund.vue?vue&type=script&lang=js&"
export * from "./StartRefund.vue?vue&type=script&lang=js&"
import style0 from "./StartRefund.vue?vue&type=style&index=0&id=2d388f6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d388f6f",
  null
  
)

export default component.exports